import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SavedSearchComponent } from '../components/saved-search/saved-search.component';
import { IconActionButtonComponent } from '../components/icon-action-button/icon-action-button.component';
import { DataTableCellDirective, DataTableComponent } from '../components/data-table/data-table.component';
import { SavedSearchSyncDirective } from './directives/saved-search-sync.directive';
import { SummernoteDirective } from '../directives/summernote.directive';
import { TkGridDirective } from './ag-grid/tk-grid.directive';

@NgModule({
  declarations: [
    SavedSearchComponent,
    SavedSearchSyncDirective,
    SummernoteDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    IconActionButtonComponent,
    DataTableComponent,
    DataTableCellDirective,
    TkGridDirective,
  ],
  exports: [
    SavedSearchComponent,
    SavedSearchSyncDirective,
    SummernoteDirective,
    IconActionButtonComponent,
    DataTableComponent,
    DataTableCellDirective,
    TkGridDirective,
  ],
})
export class SharedModule {}
